import Menu from "../components/menu";
import Table from "../util/table";
import Overlay from "../util/overlay";
import Selectblock from "../components/selectblock";
import ServiceFinder from "../components/service-finder";
import Layout from "../components/layout";
import Tabs from "../components/tabs";
import Accordion from "../components/accordion";
import Banner from "../components/banner";
import BarChart from "../components/chart/bar";
import PieChart from "../components/chart/pie";
import LineChart from "../components/chart/line";
import MiniPieChart from "../components/chart/mini-pie";
import MiniLineChart from "../components/chart/mini-line";
import Gallery from "../components/gallery/gallery";

export default {
    init() {
        var footer = "",
            menu = new Menu,
            newsletter_signup = "",
            selectblock = new Selectblock(),
            tabs = new Tabs(),
            accordion = new Accordion();

        const layout = new Layout();

        function callback() {
            this.classList.add("is-visible");
        }

    },
    finalize() {

        var table = new Table(),
            overlays = document.querySelectorAll('.overlay'),
            overlay_id,
            overlay;

        const banner = new Banner('.banner');
        new ServiceFinder();

        if (overlays !== null) {
            
            for (var i = 0; i < overlays.length; i++) {
                overlay_id = overlays[i].id;
                overlay = new Overlay({
                    trigger: document.querySelectorAll('.overlay__button--'+overlay_id)
                });
            }

        }

        if (document.querySelector(".gallery-container")) {
            new Gallery();
        }

        if (document.querySelector('.ct-chart-bar')) {
            new BarChart();
        }
        if (document.querySelector('.ct-chart-pie')) {
            new PieChart();
        }
        if (document.querySelector('.ct-chart-line')) {
            new LineChart();
        }
        if (document.querySelector('.ct-chart-mini-pie')) {
            new MiniPieChart();
        }
        if (document.querySelector('.ct-chart-mini-line')) {
            new MiniLineChart();
        }

        const search_icon = document.getElementById('search-icon');
        const search_input = document.getElementById("search-input");

        if (search_icon) {
            search_icon.addEventListener('click', function() {
                if (search_input) {
                    // tick over
                    setTimeout(function(){
                        search_input.focus();
                    }, 100);
                }
            });
        }

    }
};



// WEBPACK FOOTER //
// ./js/routes/common.js